const moment = require("moment")

module.exports = {
  changeTitleRout: function (item) {
    const auditSchoolName = item.replace(/[^a-z0-9._]+/gi, "-").toLowerCase()

    return auditSchoolName.slice(-1) === "-"
      ? auditSchoolName.slice(0, -1)
      : auditSchoolName
  },
  
  addItemLocalStorage: function (item, name) {
    let array = JSON.parse(localStorage.getItem(name)) || []

    let checkDuplicatesArray = array.find(a => a.id === item.id)
    if (!checkDuplicatesArray) {
      array.push(item)
    }
    localStorage.setItem(name, JSON.stringify(array))
  },

  getItemLocalStorage: function (name) {
    return JSON.parse(localStorage.getItem(name)) || []
  },

  formatDateTime: (str, format) => {
    return moment(str).format(format)
  },

  getHeaderClasses: shouldBeActive => {
    return {
      active: shouldBeActive ? "active" : "",
      shrinked: shouldBeActive ? "shrinked" : "",
      dark_menu: shouldBeActive ? "dark_menu" : "",
      dark_school: shouldBeActive ? "dark_school" : "",
      dark_user: shouldBeActive ? "dark_user" : "",
      triggered: shouldBeActive ? "triggered" : "",
      shrink: shouldBeActive ? "shrink" : "",
    }
  },

  addSpaceNumber: function (item) {
    if (item && item.toString().length > 4) {
      return [item.toString().slice(0, 2), item.toString().slice(2)].join(" ")
    }
    return item
  },

  addSpaceNumberRegEx: function (item) {
    return item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  },

  isSchoolRole: currentUser => {
    if (!currentUser || !currentUser.roles) {
      return false
    }
    return !!currentUser.roles.includes("school")
  },
}
